import LoadModal from '../components/LoadModal';

export const modals = {
  "LOAD_CARD_MODAL": LoadModal
};

export default modals;